(function() {
    'use strict';
    angular
        .module('MW.ContactManager.ContactManagerOutreachViewController', [
            'MW.ContactManager.OutreachService',
            'MW.Framework.ContentStreamDataFactory',
            'MW.Influencers.IcmDialogService',
            'MW.Framework.CoreUserService',
            'MW.ContactManager.ContactManagerNavigationService',
            'MW.Framework.MomentService',
            'MW.ContactManager.ContactManagerActionBarFactory',
            'MW.ContactManager.ContactManagerOutreachStatsAnalyticsController',
            'ngRoute',
            'ngMaterial',
            'MW.Configuration',
            'MW.CoreStream.CsSelectAllHeader',
            'CoreChartObject',
            'CoreColorService',
            'MW.CoreStream.ContactManagerTagService',
            'MW.Framework.InfluencerContactService',
            'MW.Influencers.SegmentTrackingService',
            'MW.Influencers.EmailAnalyticsService',
            'MW.Influencers.IcmUnsubscribeService',
            'MW.Framework.ICMEmailService',
            'MW.Framework.ICMEntitlementService'
        ])
        .controller('ContactManagerOutreachViewController', [
            '$rootScope',
            '$scope',
            'emailId',
            'approvedSenders',
            'OutreachService',
            'DialogService',
            '$sce',
            '$location',
            'moment',
            '$routeParams',
            'ContactStreamDataFactory',
            'CoreUserService',
            'ContactManagerActionBarFactory',
            'ELEVIO_CONTEXTUAL_HELP_ARTICLE_IDS',
            '$controller',
            '$timeout',
            'ContactManagerNavigationService',
            'ICM_WEB_PROXY_PREFIX',
            'CoreChartObject',
            'CoreColorService',
            'MAX_MEDIALIST_LIMIT',
            '$translate',
            'ContactManagerTagService',
            '$q',
            '$mdDialog',
            'InfluencerContactService',
            'SegmentTrackingService',
            'EmailAnalyticsService',
            'IcmUnsubscribeService',
            'ICMEmailService',
            'ICMEntitlementService',
            'RECIPIENT_TRACKING_CHECKS',
            'IRM_BASE_URL',
            ContactManagerOutreachViewController
        ]);

    function ContactManagerOutreachViewController(
        $rootScope,
        $scope,
        emailId,
        approvedSenders,
        OutreachService,
        DialogService,
        $sce,
        $location,
        moment,
        $routeParams,
        ContactStreamDataFactory,
        CoreUserService,
        ContactManagerActionBarFactory,
        ELEVIO_CONTEXTUAL_HELP_ARTICLE_IDS,
        $controller,
        $timeout,
        ContactManagerNavigationService,
        ICM_WEB_PROXY_PREFIX,
        CoreChartObject,
        CoreColorService,
        MAX_MEDIALIST_LIMIT,
        $translate,
        ContactManagerTagService,
        $q,
        $mdDialog,
        InfluencerContactService,
        SegmentTrackingService,
        EmailAnalyticsService,
        IcmUnsubscribeService,
        ICMEmailService,
        ICMEntitlementService,
        RECIPIENT_TRACKING_CHECKS,
        IRM_BASE_URL
    ) {
        var getRequestParams,
            ContactManagerOutreachStatsAnalyticsController;

        ContactManagerOutreachStatsAnalyticsController = $controller('ContactManagerOutreachStatsAnalyticsController', {});

        angular.extend(this, ContactManagerOutreachStatsAnalyticsController);

        this.shouldTrack = approvedSenders.some(sender => {
            return sender.shouldTrack === true;
        });

        this.previousPage = ContactManagerNavigationService.getPreviousLocation();
        this.SegmentTrackingService = SegmentTrackingService;
        this.$rootScope = $rootScope;
        this.$scope = $scope;
        this.$routeParams = $routeParams;
        this.$location = $location;
        this.$timeout = $timeout;
        this.OutreachService = OutreachService;
        this.EmailAnalyticsService = EmailAnalyticsService;
        this.UnsubscribeService = IcmUnsubscribeService;
        this.DialogService = DialogService;
        this.$sce = $sce;
        this.moment = moment;
        this.elevioIdsObj = ELEVIO_CONTEXTUAL_HELP_ARTICLE_IDS;
        this.CoreChartObject = CoreChartObject;
        this.distributionId = emailId;
        this.CoreColorService = CoreColorService;
        this.MAX_MEDIALIST_LIMIT = MAX_MEDIALIST_LIMIT;
        this.$translate = $translate;
        this.ContactManagerTagService = ContactManagerTagService;
        this.InfluencerContactService = InfluencerContactService;
        this.ICMEmailService = ICMEmailService;
        this.ICMEntitlementService = ICMEntitlementService;
        this.$q = $q;
        this.$mdDialog = $mdDialog;
        this.CoreUserService = CoreUserService;
        this.RECIPIENT_TRACKING_CHECKS = RECIPIENT_TRACKING_CHECKS;
        this.IRM_BASE_URL = IRM_BASE_URL;

        this.unsubscribeDropDownOptions = [
            {id: 'all', name: this.$translate.instant('All')},
            {id: 'frequency', name: this.$translate.instant('Emails come too frequently')},
            {id: 'irrelevant', name: this.$translate.instant('Emails are not relevant')},
            {id: 'spam', name: this.$translate.instant('Emails are spam')},
            {id: 'none', name: this.$translate.instant('No specific reason')},
            {id: 'other', name: this.$translate.instant('Other')}
        ];
        this.selectedUnsubscribeOption = this.unsubscribeDropDownOptions[0];

        this.clickToOpenDropDownOptions = [];
        this.selectedClickToOpenOption = {};

        // translations
        this.previewText = this.$translate.instant('Preview');
        this.allText = this.$translate.instant('All');
        this.openRateText = this.$translate.instant('Open Rate');
        this.clickToOpenRateText = this.$translate.instant('Click to Open Rate');
        this.unsubscribeRateText = this.$translate.instant('mw-outreach-collection__engagement-widget-unsubscribe-rate');
        this.unsubscribeText = this.$translate.instant('Unsubscribe');

        this.firstFourtyEightText = this.$translate.instant('icm-outreach-stats__first-fourty-eight');
        this.moreRecipientsText = this.$translate.instant('more recipients...');
        this.errorMessageText = this.$translate.instant('Unable to retrieve email');
        this.notAvailableText = this.$translate.instant('N/A');
        this.lastActivityText = this.$translate.instant('Last activity');

        this.emailInfo = '';
        this.scheduledMomentDate = '';
        this.countLabel = '';
        this.pageTitle = 'Sent Email';
        this.isFirstFourtyEight = true;
        this.failedRetrievingStats = false;
        this.readyToLoadView = false;
        this.ContactManagerActionBarFactory = new ContactManagerActionBarFactory(this.ContactSelector);

        this.ContactStreamData = new ContactStreamDataFactory();

        this.CoreUserService.hasPermissions().then(function (isPermissions) {
            this.isPermissions = isPermissions;
        }.bind(this));

        this.isInfluencerAppEntitled = false;
        if(this.CoreUserService.isInfluencerAppEntitled === '') {
            this.ICMEntitlementService.getInfluencerAppEntitlement()
                .then(function getAccountEntitlementThen(entitlement) {
                    if(entitlement) {
                        this.isInfluencerAppEntitled = true;
                    }
                }.bind(this));
        } else if(this.CoreUserService.isInfluencerAppEntitled) {
            this.isInfluencerAppEntitled = true;
        }

        this.subNavItems = [
            {
                name: this.previewText,
                route: 'preview',
                data: ''
            }, {
                name: this.openRateText,
                route: 'open_rate',
                data: ''
            }, {
                name: this.clickToOpenRateText,
                route: 'click_to_open_rate',
                data: ''
            }, {
                name: this.unsubscribeText,
                route: 'unsubscribe',
                data: ''
            }
        ];

        /*jshint camelcase:false*/
        this.viewPartials = {
            preview: 'icm-web/views/partials/outreach_stats_preview',
            open_rate: 'icm-web/views/partials/outreach_stats_open_rate',
            click_to_open_rate: 'icm-web/views/partials/outreach_stats_click_to_open_rate',
            unsubscribe: 'icm-web/views/partials/outreach_stats_unsubscribe'
        };

        this.outreachStats = {
            openRate: '--',
            clickToOpenRate: '--',
            unsubscribeRate: '--',
            open: 0,
            click: 0,
            unsubscribe: 0,
            delivered: 0
        };
        this.toField = [];

        if(!this.$routeParams.view || !this.subNavItems.some(function(navItem) {
            return navItem.route === this.$routeParams.view;
        }.bind(this))) {
            $timeout(function() {
                this.$location.search('view', 'preview');
                this.loadView(this.$routeParams.view);
            }.bind(this), 500);
        }
        else {
            this.loadView(this.$routeParams.view);
        }

        getRequestParams = function getRequestparams(url) {
            var params = {},
                pathStr = url.split('?')[0],
                searchStr = url.split('?')[1],
                pathWithoutHost = url.replace($location.protocol() + '://' + location.host,''),
                prefixRegEx = ICM_WEB_PROXY_PREFIX ? new RegExp('^\/?' + ICM_WEB_PROXY_PREFIX) : '';

            if(searchStr !== undefined) {
                var paramsStr = searchStr.split('&');
                for(var key in paramsStr) {
                    if(paramsStr.hasOwnProperty(key)){
                        params[paramsStr[key].split('=')[0]] = paramsStr[key].split('=')[1];
                    }
                }
            }
            return {
                path: pathStr,
                params: params,
                pathWithoutHost: pathWithoutHost,
                url: pathWithoutHost.replace(prefixRegEx, '')
            };
        };

        this.$scope.$on('$locationChangeStart', function(event, newLocation, oldLocation) {
            var newLocationObject = getRequestParams(newLocation),
                oldLocationObject = getRequestParams(oldLocation);

            // when paths are the same, it means we are switching "sub-nav" views within the full screen email preview
            if(newLocationObject.path === oldLocationObject.path) {
                this.ContactSelector.deselectAll();
                this.loadView(newLocationObject.params.view);
            }
            // else - means we should have attempted to close the preview and head back to the outreach page. this should be handled by the closeStats method attached to the "X" button on the preview page
        }.bind(this));
        this.ICMEntitlementService.getIcmContactExportLimit()
            .then(entitlementLimit => {
                this.exportLimit = entitlementLimit;
            });

        this._prepareOpenRateDropdown();
        this.getEmailById(emailId);
        this.getOutreachStatsById(emailId);
    }

    ContactManagerOutreachViewController.prototype.getEmailById = function getEmailById(emailId) {
        this.OutreachService.getEmailById(emailId)
            .then(function (response) {
                var _contactLabel = (response.recipients.length === 1) ? 'icm-outreach__emails--single-contact' : 'icm-outreach__emails--multiple-contacts',
                medialistsArray = [],
                recipientsArray = [],
                recipients = [],
                mediaListKeysArray = [],
                medialistName;

                this.emailInfo = response;
                this.scheduledMomentDate = this.moment(this.emailInfo.scheduledDate).format('ddd, D MMM YYYY') + ' ' +  new Date(this.emailInfo.scheduledDate).toTimeString().replace(/GMT/ig, '');
                this.previewBodyHtml = this.$sce.trustAsHtml(this.emailInfo.bodyHtml);
                this.dateRangeFromCreation = this.moment(this.emailInfo.created).format('MMMM D, YYYY') + ' - ' + this.moment().format('MMMM D, YYYY');
                this.countLabel = this.$translate.instant(_contactLabel, {recipientCount: this.emailInfo.recipients.length});
                // To fetch medialists name
                if(this.emailInfo && this.emailInfo.recipientsMetaData && this.emailInfo.recipientsMetaData.mediaLists) {
                    medialistName = this.emailInfo.recipientsMetaData.mediaLists;
                    mediaListKeysArray = Object.keys(medialistName);
                    for(var j = 0; j < mediaListKeysArray.length; j++) {
                        var len,
                            mediaListRecipients = [],
                            comparator;
                        if(medialistName[mediaListKeysArray[j]].recipients) {
                            len = medialistName[mediaListKeysArray[j]].recipients.length;
                            comparator = (len <= 5) ? len : 5;
                            for(var val=0; val < comparator; val++) {
                                mediaListRecipients.push(medialistName[mediaListKeysArray[j]].recipients[val].email);
                            }
                        }
                        mediaListRecipients = mediaListRecipients.toString().replace(/,/g,'\n');
                        if(len > 5) {
                            mediaListRecipients += '\n' + (len-5) + ' ' + this.moreRecipientsText;
                        }
                        medialistsArray.push({
                            name: medialistName[mediaListKeysArray[j]].name +' ('+ len +')',
                            recipients: mediaListRecipients
                        });
                    }
                    this.toField.mediaListNames = medialistsArray;
                }

                // To fetch recipients name
                if(this.emailInfo && this.emailInfo.recipientsMetaData && this.emailInfo.recipientsMetaData.recipients) {
                    recipients = this.emailInfo.recipientsMetaData.recipients;
                    for(var k = 0; k < recipients.length; k++) {
                        recipientsArray.push({
                            name: recipients[k].name,
                            email: recipients[k].email
                        });
                    }
                    this.toField.contactRecipients = recipientsArray;
                }

                if(!this.outreachStatsDetailToggle) {
                    this.isFirstFourtyEight = (this.moment(response.scheduledDate) > this.moment().subtract(48, 'hours'));
                }
            }.bind(this))
            .catch(function () {
                this.DialogService.flashError(this.errorMessageText);
            }.bind(this));
    };

    ContactManagerOutreachViewController.prototype.getOutreachStatsById = function getOutreachStatsById(distributionId) {
        let promises = [],
            statsObject;

        promises.push(this.EmailAnalyticsService.getStatsCount(distributionId, 'all'));
        promises.push(this.UnsubscribeService.getDistributionUnsubscribeTotal(distributionId));

        const _formatRate = (dividend, divisor) => {
            return Math.min(Number(((dividend / divisor) * 100).toFixed(2)), 100);
        };

        return new Promise((resolve, reject) => {
            Promise.all(promises)
                .then((objects) => {
                    let stats = objects[0],
                        unsubscribe = objects[1],
                        open = stats.open || 0,
                        delivered = stats.delivered || 0,
                        click = stats.click || 0,
                        openRate = stats.openRate,
                        ctoRate = stats.ctoRate,
                        unsubscribeRate = 0;

                    if(delivered > 0) {
                        unsubscribeRate = _formatRate(unsubscribe, delivered);
                    }

                    statsObject = {
                        openRate: openRate,
                        ctoRate: ctoRate,
                        unsubscribeRate: unsubscribeRate,
                        open: open,
                        click: click,
                        unsubscribe: unsubscribe,
                        delivered: delivered
                    };
                    return this.setEmailAnalytics(statsObject);
                }).then(() => {
                    resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    };

    ContactManagerOutreachViewController.prototype.setEmailAnalytics = function setEmailAnalytics(stats) {
        return new Promise((resolve) => {
            this.outreachStats = stats;
            this.subNavItems[1].data = '(' + this.outreachStats.openRate + '%)';
            this.subNavItems[2].data = '(' + this.outreachStats.ctoRate + '%)';
            this.subNavItems[3].data = '(' + this.outreachStats.unsubscribeRate + '%)';

            this.readyToLoadView = true;
            this.loadView(this.view);
            resolve();
        });
    };

    /**
     * Redirect to outreach page on stats close
     */
    ContactManagerOutreachViewController.prototype.closeStats = function closeStats() {
        angular.element('.outreachStatsContainer').addClass('hideContainer');

        // if the ref was "cp" that means we need to navigate back to Media Relations Contact Profile. since this is a separate web app
        //   the previous page logic doesn't work here. we'll grab the ID and redirect
        var shouldGoBackToMrContactProfile = ((this.$location.search().ref === 'cp') && this.$location.search().id);

        //Let the animation complete
        this.$timeout(function() {
            // if we came from an app page, go back there
            // else go home
            if(shouldGoBackToMrContactProfile) {
                window.location.href = `${this.IRM_BASE_URL}/contact/${this.$location.search().id}`;
            } else if(this.previousPage && this.previousPage.indexOf('/login/success') === -1) {
                this.$location.url(this.previousPage);
            } else {
                this.$location.url('/');
            }
        }.bind(this), 300);
    };

    ContactManagerOutreachViewController.prototype.loadView = function loadView(view) {
        this.view = view;
        this.currentView = this.viewPartials[view];

        if(this.readyToLoadView) {
            if (view === 'open_rate') {
                this.EmailAnalyticsService.getStatsCount(this.distributionId, 'open').then((openData) => {
                    this._buildOpenRateChartAnalytics(openData);
                });
            } else if (view === 'click_to_open_rate') {
                this.EmailAnalyticsService.getStatsCount(this.distributionId, 'click').then((clickData) => {
                    this._buildClickToOpenRateChartAnalytics(clickData);
                });
            } else if (view === 'unsubscribe') {
                this._buildUnsubscribeChartAnalytics();
            }
        }
    };

    ContactManagerOutreachViewController.prototype.loadUnsubscribedContacts = function loadUnsubscribedContacts(reason) {
        var query = {
                distributionId: this.distributionId,
                appIds: 'ICM'
            };

        if (reason && reason.id && reason.id !== 'all') {
            query.reason = reason.id;
            this.selectedUnsubscribeOption = reason;
        }

        this.ContactSelector.deselectAll();
        this.ContactStreamData.getUnsubscribed(query).then(function() {
            this._setupContactPredictionValues();
        }.bind(this));
    };

    ContactManagerOutreachViewController.prototype._prepareClickToOpenDropdown = function _prepareClickToOpenDropdown(linkArray) {
        this.clickToOpenDropDownOptions = linkArray.map(function(link) {
            return {name: link};
        });

        this.clickToOpenDropDownOptions.unshift({name: 'All'});
        this.selectedClickToOpenOption = this.clickToOpenDropDownOptions[0];
    };

    ContactManagerOutreachViewController.prototype.loadClickToOpenRateContacts = function loadClickToOpenRateContacts(link) {
        let query = {
            page: 0,
            pageSize: 25,
            pathParams: {
                statType: 'click',
                distributionId: this.distributionId
            }
        };

        if(link && link.name && (link.name.toLowerCase() !== 'all')) {
            query.clickLink = link.name;
        }

        this.ContactSelector.deselectAll();
        this.ContactStreamData.getContactsByStat(query);
    };

    ContactManagerOutreachViewController.prototype._prepareOpenRateDropdown = function _prepareOpenRateDropdown() {
        this.uniqueOpenRateDropDownOptions = [
            {id: 'all', name: this.allText},
            { id: 'opened', name: this.$translate.instant('icm-outreach-stats__open-rate--opened')},
            { id: 'unopened', name: this.$translate.instant('icm-outreach-stats__open-rate--unopened')},
            { id: 'bounces', name: this.$translate.instant('Bounced')}
        ];

        if(this.RECIPIENT_TRACKING_CHECKS){
            this.uniqueOpenRateDropDownOptions.push({id: 'untracked', name: this.$translate.instant('icm-outreach-stats__open-rate--untracked')});
        }
        this.selectedOpenRateOption = this.uniqueOpenRateDropDownOptions[0];
    };

    ContactManagerOutreachViewController.prototype.loadOpenRateContacts = function loadOpenRateContacts(type) {
        let translationScope;
        let query = {
                page: 0,
                pageSize: 25,
                pathParams: {
                    statType: 'open',
                    distributionId: this.distributionId
                }
            };

        if(type && type.id && (type.id.toLowerCase() !== 'all')) {
            query.stat = type.id;
            this.selectedOpenRateOption = type;
        }

        if(this.selectedOpenRateOption.id === this.uniqueOpenRateDropDownOptions[0].id) {
             // all open types
            this.noContactsMessage = this.$translate.instant('No Contacts');
         } else {
            // specified open type
            translationScope = {
                type: this.selectedOpenRateOption.id
            };

            this.noContactsMessage = this.$translate.instant('icm-outreach__stats--no-emails-msg', translationScope);
         }
        this.ContactSelector.deselectAll();
        this.ContactStreamData.getContactsByStat(query);
    };

    ContactManagerOutreachViewController.prototype._decodeHTML = function _decodeHTML(encodedHTMLString) {
        // new $translate.instant return encoded HTML
        var div = document.createElement('div');
        div.innerHTML = encodedHTMLString;
        return div.textContent;
    };

    ContactManagerOutreachViewController.prototype._buildOpenRateChartAnalytics = function _buildOpenRateChartAnalytics(openStatsObject) {
        var openRate = this.openRateText,
            translatePayload = {
                openRateText: '<span data-elevio-inline=\''+this.elevioIdsObj.openRateArticle+'\'>' + openRate + '</span>',
                openRatePercent: this.outreachStats.openRate,
                totalOpened: this.outreachStats.open || 0,
                deliveredMails: this.outreachStats.delivered
            },
            openRateSummary = this.$translate.instant('icm-outreach__stats--openRate-summary', translatePayload),
            chartDataObject = new this.CoreChartObject({
                type: 'column',
                view: 'max',
                percent : false,
                animate: true,
                yAxisTitle: 'Recipients'
            }),
            drilldownFunction,
            tooltipFunction;

        this.openStatsObject = openStatsObject;
        this.openRateSummary = this.$sce.trustAsHtml(this._decodeHTML(openRateSummary));

        this.openRateChartData = {};

        tooltipFunction = function tooltipFunction(categoryObj) {
            var tooltipText = '',
                translationScope = {};

            switch(categoryObj.type) {
                case 'bounces':
                    translationScope = {
                        uniqueSoftBounces: this.openStatsObject.softBounces,
                        uniqueHardBounces: this.openStatsObject.hardBounces,
                        uniqueOtherBouncesCount: this.openStatsObject.otherBounces
                    };

                    tooltipText += this.$translate.instant('icm-outreach__stats--undeliverable-summary', translationScope);

                    break;
                case 'unopened':
                case 'unread':
                    tooltipText += this.$translate.instant('icm-outreach-stats__open-rate--unopened-text');
                    break;
                case 'opened':
                case 'seen':
                case 'skimmed':
                case 'read':
                    tooltipText += this.$translate.instant('icm-outreach-stats__open-rate--opened-text');
                    break;
                case 'untracked':
                    tooltipText += this.$translate.instant('icm-outreach-stats__open-rate--untracked-text');
                    break;
            }

            return tooltipText;
        }.bind(this);

        drilldownFunction = function drilldownFunction(chartDataObject) {
            var type = chartDataObject.type.toLowerCase();

            this.uniqueOpenRateDropDownOptions.some(function(openRateOption) {
                if(openRateOption.id === type) {
                    this.selectedOpenRateOption = openRateOption;
                    return true;
                }
            }.bind(this));

            this.loadOpenRateContacts(this.selectedOpenRateOption);
        }.bind(this);

        // build the graph
        this.openRateChartData = this.CoreCommon.mergeRecursive(chartDataObject, this.TransformOutreachStatsChartService.readyChartOpenRateStatsData(openStatsObject, tooltipFunction, drilldownFunction));

        // build the contact stream
        this.openRateSortField = 'date';
        this.loadOpenRateContacts();
        this.selectedOpenRateOption = this.uniqueOpenRateDropDownOptions[0];
    };

    ContactManagerOutreachViewController.prototype._buildClickToOpenRateChartAnalytics = function _buildClickToOpenRateChartAnalytics(clickData) {
        this.ctorData = true;
        if(!clickData.length) {
            this.ctorData = false;
            return;
        }

        var clickToOpenRate = this.clickToOpenRateText,
            clickToOpenRateSummary = 'icm-outreach__stats--clickToOpen-summary',
            translationScope = {
                clickToOpenRateText: '<span data-elevio-inline=\'' + this.elevioIdsObj.clickToOpenRateArticle +'\'>' + clickToOpenRate + '</span>',
                ctor: this.outreachStats.ctoRate,
                uniqueClickEmailsCount: this.outreachStats.click,
                uniqueOpensCount: this.outreachStats.open
            },
            chartDataObject = new this.CoreChartObject({
                type: 'bar',
                view: 'max',
                percent: false
            }),
            dataFormatter = {
                xAxis: {
                    categories: []
                },
                series: [{
                    data: []
                }]
            },
            clickedLinkArray = clickData.map(click => {
                return click.clickLink;
            });

        function _prepareTopTenClicks(stats, chartData) {
            var descSortedClicks,
                i,
                numOfIterations;

            descSortedClicks = stats.sort(function(a, b) {
                if(a.count > b.count) {
                    return -1;
                }

                if(a.count < b.count) {
                    return 1;
                }

                return 0;
            });

            numOfIterations = (descSortedClicks.length > 10) ? 10 : descSortedClicks.length;

            for(i=0; i<numOfIterations; i++) {
                chartData.xAxis.categories.push(descSortedClicks[i].clickLink);
                chartData.series[0].data.push({y: descSortedClicks[i].count});
            }

            return chartData;
        }

        dataFormatter = _prepareTopTenClicks(clickData, dataFormatter);
        chartDataObject = this.CoreCommon.mergeRecursive(chartDataObject, dataFormatter);
        this.clickToOpenRateSummary = this.$sce.trustAsHtml(this._decodeHTML(this.$translate.instant(clickToOpenRateSummary, translationScope)));

        this.ctorChartData = {};

        // build the graph
        this.ctorChartData = this.CoreCommon.mergeRecursive(chartDataObject, this.TransformOutreachStatsChartService.readyChartCTORData(this.outreachStats,
                (chartDataObject) => {
                    var link = chartDataObject.category;

                    this.clickToOpenDropDownOptions.some(function(clickToOpenOption) {
                        if(clickToOpenOption.name === link) {
                            this.selectedClickToOpenOption = clickToOpenOption;
                            return true;
                        }
                    }, this);

                    this.loadClickToOpenRateContacts({name: link});
                }
        ));

        // build the contact stream
        this.clickToOpenSortField = 'date';
        this._prepareClickToOpenDropdown(clickedLinkArray);
        this.loadClickToOpenRateContacts({name: 'all'});
    };

    ContactManagerOutreachViewController.prototype._formatUnsubscribeData = function _formatUnsubscribeData(unsubscribes) {
        let unsubscribesObj = {
            reasons: {
                frequency: 0,
                irrelevant: 0,
                spam: 0,
                none: 0,
                other: 0
            }
        };

        for (let i = 0; i < unsubscribes.length; i++) {
            if (unsubscribesObj.reasons[unsubscribes[i].reason] !== undefined) {
                unsubscribesObj.reasons[unsubscribes[i].reason] += 1;
            }
        }

        return unsubscribesObj;
    };

    ContactManagerOutreachViewController.prototype._buildUnsubscribeChartAnalytics = function _buildUnsubscribeChartAnalytics() {
        this.unsubscribeData = true;
        if((!this.outreachStats.unsubscribe || !this.outreachStats.delivered) && this.shouldTrack) {
            this.unsubscribeData = false;
            return;
        }

        if(!this.outreachStats.unsubscribe && !this.shouldTrack){
            this.unsubscribeData = false;
            return;
        }

        this.UnsubscribeService.getDistributionUnsubscribes(this.distributionId)
            .then((results) => {
                this.unsubscribesObj = this._formatUnsubscribeData(results.unsubscribes);

                var unsubscribeRateSummary = 'icm-outreach__stats--unsubscribeRate-summary',
                    translationScope = {
                        unsubscribeRateText: '<span data-elevio-inline=\''+this.elevioIdsObj.unsubscribeArticle+'\'>'+this.unsubscribeRateText+'</span>',
                        unsubscribeRate: this.outreachStats.unsubscribeRate,
                        unsubscribeRateCount: this.outreachStats.unsubscribe,
                        uniqueDeliverdCount: this.outreachStats.delivered
                    },
                    chartDataObject = new this.CoreChartObject({
                        type: 'pie',
                        view: 'max',
                        percent: false
                    }),
                    reasonArray = Object.keys(this.unsubscribesObj.reasons),
                    donutChartData = [],
                    colorSet = this.CoreColorService.getColors(),
                    drilldownFunction;

                this.unsubscribeRateSummary = this.$sce.trustAsHtml(this._decodeHTML(this.$translate.instant(unsubscribeRateSummary, translationScope)));

                for(let i=0; i<reasonArray.length; i++) {
                    var translatedReason,
                        count = this.unsubscribesObj.reasons[reasonArray[i]];

                    for (let j=0; j < this.unsubscribeDropDownOptions.length; j++) {
                        if (reasonArray[i] === this.unsubscribeDropDownOptions[j].id) {
                            translatedReason = this.unsubscribeDropDownOptions[j].name;
                        }
                    }
                    if(count > 0) {
                        donutChartData.push({
                            name: translatedReason,
                            color: colorSet[i],
                            y: count
                        });
                    }
                }

                drilldownFunction = function drilldownFunction(reason) {
                    let reasonObj;

                    if(reason && reason.name) {
                        for (let i = 0; i < this.unsubscribeDropDownOptions.length; i++) {
                            if (reason.name === this.unsubscribeDropDownOptions[i].name && this.unsubscribeDropDownOptions[i].id !== 'all') {
                                this.selectedUnsubscribeOption = this.unsubscribeDropDownOptions[i];
                                reasonObj = {id: this.unsubscribeDropDownOptions[i].id, name: reason.name};
                            }
                        }
                    }

                    this.loadUnsubscribedContacts(reasonObj);
                }.bind(this);

                // build the graph
                this.unsubscribeChartData = this.CoreCommon.mergeRecursive(chartDataObject, this.TransformOutreachStatsChartService.readyChartUnsubscribeData(donutChartData, drilldownFunction));

                // build the contact stream
                this.unsubscribeSortField = 'date';
                this.loadUnsubscribedContacts();
                this.selectedUnsubscribeOption = this.unsubscribeDropDownOptions[0];
            }).catch(() => {});
    };

    ContactManagerOutreachViewController.prototype.changeView = function changeView(subNavItem) {
        if(subNavItem) {
            this.$location.search('view', subNavItem);
        }
    };

    ContactManagerOutreachViewController.prototype.getSelectedCount = function getSelectedCount(selectedItems) {
        return Object.keys(selectedItems).length;
    };

    ContactManagerOutreachViewController.prototype.nextContactPage = function nextContactPage() {
        this.ContactStreamData.nextPage().then(function() {
            if(this.ContactSelector.allSelected && this.ContactStreamData.contactArray.length > 25) {
                this.ContactSelector.selectAllForNextPage(this.ContactStreamData.contactArray,  null, null, this.predictionContactFilter);
            }
        }.bind(this));
    };

    ContactManagerOutreachViewController.prototype.addSelectedContactsByClicksToMediaList = function addSelectedContactsByClicksToMediaList(link) {
        var criteria = {
                pageSize: this.MAX_MEDIALIST_LIMIT,
                page: 0,
                pathParams: {
                    distributionId: this.distributionId,
                    statType: 'click'
                }

            };

        if(link && (link.toLowerCase() !== 'all')) {
            criteria.clickLink = link;
        }

        this.addSelectedToMediaList(criteria);
    };

    ContactManagerOutreachViewController.prototype.addSelectedContactsByOpensToMediaList = function addSelectedContactsByOpensToMediaList(statType) {
        var criteria = {
                stat: statType || '',
                pageSize: this.MAX_MEDIALIST_LIMIT,
                page: 0,
                pathParams: {
                    distributionId: this.distributionId,
                    statType: 'open'
                }
            };

        this.addSelectedToMediaList(criteria);
    };

    ContactManagerOutreachViewController.prototype.addSelectedUnsubscribesToMediaList = function addSelectedUnsubscribesToMediaList() {
        var criteria = {
                distributionId: this.distributionId,
                appIds: 'ICM',
                reason: this.selectedUnsubscribeOption.id === 'all' ? undefined : this.selectedUnsubscribeOption.id,
                pageSize: this.MAX_MEDIALIST_LIMIT,
                page: 0
            };

        this.addSelectedToMediaList(criteria);
    };

    ContactManagerOutreachViewController.prototype.addSelectedToMediaList = function addSelectedToMediaList(criteria) {
        criteria = criteria || {};
        if(this._checkIfOverSelectionLimit(this.MAX_MEDIALIST_LIMIT)) {
            let manageListLimitWarning = document.querySelector('manage-list-limit-warning');
            manageListLimitWarning.open();
        }
        else {
            window.addEventListener('icm-lists-updated', this.resetSelectedStats, {once: true});
            if(this.ContactSelector.trueAllSelected){
                let getContactByStats;

                if(criteria && criteria.appIds){
                    getContactByStats = this.getContactIdsForUnsubscribeStats.bind(this);
                } else {
                    getContactByStats = this.getContactIdsForStats.bind(this);
                }

                getContactByStats(criteria).then(results =>{
                    this.openManageListModal(results);
                });
            } else {
                let validIds = [],
                    invalidEmails = [];

                Object.keys(this.ContactSelector.selectedItems).forEach((key) => {
                    if(key.indexOf('other_contact') === -1){
                        validIds.push(key);
                    } else {
                        invalidEmails.push(key.replace('other_contact_',''));
                    }
                });
                this.openManageListModal({
                    validIds: validIds,
                    invalidEmails: invalidEmails
                });
            }
        }
    };

    ContactManagerOutreachViewController.prototype.getContactIdsForUnsubscribeStats = function getContactIdsForUnsubscribeStats(criteria) {
        return new Promise((resolve, reject) => {
            this.InfluencerContactService.getUnsubscribed(criteria).then(results =>{
                let validIds = [],
                   invalidEmails = [];

                results.hits.forEach((contact) =>{
                    (contact && contact.id && contact.id.indexOf('other_contact') === -1) ? validIds.push(contact.id) : invalidEmails.push(contact.id.replace('other_contact_','')); // jshint ignore:line
                });

                resolve({
                    validIds: validIds,
                    invalidEmails: invalidEmails
                });
            }).catch((err) => {
                reject(err);
            });
         });
    };

    ContactManagerOutreachViewController.prototype.getContactIdsForStats = function getContactIdsForStats(criteria) {
        return new Promise((resolve, reject) => {
            this.InfluencerContactService.getContactIdsByStat(criteria).then(results =>{
                let validIds = [],
                   invalidEmails = [];

                results.forEach((contact) =>{
                    (contact && contact.contactIds && contact.contactIds.length > 0) ? validIds.push(contact.contactIds[0]) : invalidEmails.push(contact.emailAddress); // jshint ignore:line
                });

                resolve({
                    validIds: validIds,
                    invalidEmails: invalidEmails
                });
            }).catch((err) => {
                reject(err);
            });
         });
    };

    ContactManagerOutreachViewController.prototype.warningNonValidContacts = function warningNonValidContacts(nonValidContacts, validContactCount){
        return this.$mdDialog.show(
            this.$mdDialog.mwConfirm()
                .title(this.$translate.instant('icm-outreach__stats--add-to-list-warning-title', {contactCount:validContactCount}))
                .textContent(this.$translate.instant('icm-outreach__stats--add-to-list-warning-text', {emailList:nonValidContacts.join(', ')}))
                .ok('OK')
                .cancel('cancel')
                .multiple(true)
                .parent(angular.element(document.getElementsByClassName('mw-flexi-modal')[0]))
        );
    };

    ContactManagerOutreachViewController.prototype.openManageListModal = function openManageListModal(contacts) {
        let manageListDialog = document.querySelector('icm-manage-lists-dialog');
        if(contacts.invalidEmails.length > 0){
            this.warningNonValidContacts(contacts.invalidEmails, contacts.validIds.length).then(() => {
                if(contacts.validIds.length > 0) {
                    manageListDialog.open(contacts.validIds);
                }
           });
        } else {
            manageListDialog.open(contacts.validIds);
        }
    };

    ContactManagerOutreachViewController.prototype.resetSelectedStats = function resetSelectedStats() {
        let _this = angular.element(document.getElementsByClassName('outreachStatsContainer')).scope().outreachViewController;
        _this.ContactSelector.deselectAll();
        _this.predictionContactFilter = {};
        _this.$scope.$apply();
    };

    ContactManagerOutreachViewController.prototype.exportClickToOpenRateContactsToCSV = function exportClickToOpenRateContactsToCSV(clickedLink, ev) {
        if(clickedLink && (clickedLink.toLowerCase() !== 'all')) {
            this.exportContactsToCSV('clicks', ev, clickedLink);
        } else {
            this.exportContactsToCSV('clicks', ev);
        }
    };

    ContactManagerOutreachViewController.prototype.exportOpenRateContactsToCSV = function exportOpenRateContactsToCSV(stat, ev) {
        this.exportContactsToCSV(stat, ev);
    };

    ContactManagerOutreachViewController.prototype.exportUnsubscribedContactsToCSV = function exportUnsubscribedContactsToCSV(ev) {
        this.exportContactsToCSV('unsubscribes', ev);
    };

    ContactManagerOutreachViewController.prototype.exportContactsToCSV = function exportContactsToCSV(type, ev, clickedLink) {
        var pageSize = this.exportLimit,
        // limit the file name to 200 because whose going to want a name longer than that? Also it errors on export if the file name is too long...
            fileName = this.emailInfo.subject.substring(0,200);

        type = type || '';
        if(this._checkIfOverSelectionLimit(this.exportLimit)) {
            this.DialogService.alert(this.$translate.instant('icm-export__exceed-limit-message', {limit: this.exportLimit}), this.$translate.instant('Selection Too Large'));
        } else {
            this.$mdDialog.show(
                this.$mdDialog.mwAlert()
                    .class('legal-message')
                    .textContent(this.$translate.instant('icm-export__legal-message'))
                    .ok(this.$translate.instant('OK'))
                    .targetEvent(ev)
            ).then(() => {
                switch(type.toLowerCase()) {
                    case 'unsubscribes':
                        var reason = this.selectedUnsubscribeOption.id === 'all' ? undefined : this.selectedUnsubscribeOption.id;

                        this.ContactManagerActionBarFactory.exportUnsubscribedContactsToCSV(fileName, this.distributionId, pageSize, reason);
                        break;
                    case 'delivered':
                    case 'bounces':
                    case 'unread':
                    case 'seen':
                    case 'skimmed':
                    case 'read':
                    case 'opened':
                    case 'unopened':
                    case 'untracked':
                        this.ContactManagerActionBarFactory.exportContactsByStatToCsv(fileName, this.distributionId, pageSize, type);
                        break;
                    case 'clicks':
                        this.ContactManagerActionBarFactory.exportContactsByStatToCsv(fileName, this.distributionId, pageSize, type, clickedLink);
                        break;
                    default:
                        this.ContactManagerActionBarFactory.exportContactsByStatToCsv(fileName, this.distributionId, pageSize, 'all');
                        break;
                }

                this.trackSegmentEvent(type);
            });
        }
    };

    ContactManagerOutreachViewController.prototype.trackSegmentEvent = function trackSegmentEvent(type){
        var parentType = this.mapTypeToSegmentParentType(type),
            numberOfContacts = this.ContactSelector.trueAllSelected ? this.ContactStreamData.totalContacts : this.getSelectedCount(this.ContactSelector.selectedItems);
        this.SegmentTrackingService.trackEvent('export_contact', null, numberOfContacts, parentType, type);
    };

    ContactManagerOutreachViewController.prototype.mapTypeToSegmentParentType = function mapTypeToSegmentParentType(type){
        var parentType = '';

        switch(type.toLowerCase()) {
            case 'unsubscribes':
                parentType = 'ICM_analytics_unsubscribe';
                break;
            case 'delivered':
            case 'bounces':
            case 'unread':
            case 'seen':
            case 'skimmed':
            case 'read':
                parentType = 'ICM_analytics_open_rate';
                break;
            case 'clicks':
                parentType = 'ICM_analytics_CTOR';
                break;
            default:
                parentType = 'all';
                break;
        }

        return parentType;
    };

    ContactManagerOutreachViewController.prototype.openRateCompose = function openRateCompose(statType) {
        statType = statType || 'all';

        this.compose(statType);
    };

    ContactManagerOutreachViewController.prototype.clickToOpenRateCompose = function clickToOpenRateCompose(link) {
        var clickedLink = null;

        if(link && (link.toLowerCase() !== 'all')) {
            clickedLink = link;
        }

        this.compose('clicks', clickedLink);
    };

    ContactManagerOutreachViewController.prototype.compose = function compose(stat, clickedLink) {
        var setRecipients = function setRecipients() {
                return this.$q(function (resolve) {
                    var selectedContacts,
                        selectedContactArray = [],
                        query;

                    if (this.ContactSelector.trueAllSelected) {
                        query = {
                            distributionId: this.distributionId,
                            type: stat,
                            page: 0,
                            pageSize: 1000
                        };

                        if(clickedLink) {
                            query.clickedLink = clickedLink;
                        }

                        this.InfluencerContactService.getOpenRate(query).then(function(results) {
                            results.hits.forEach(function (contactObject) {
                                if (contactObject.id.indexOf('other_contact_') > -1) {
                                    contactObject.id = null;
                                    contactObject.name.fullName = contactObject.contactInfo.email[0].address;
                                }

                                selectedContactArray.push(contactObject);
                            });

                            this.ICMEmailService.setContactRecipients(selectedContactArray);
                            resolve(selectedContactArray);
                        }.bind(this));
                    } else {
                        selectedContacts = angular.copy(this.ContactSelector.selectedItems);

                        selectedContactArray = Object.keys(selectedContacts).map(function (selectedContactKey) {
                            if (selectedContacts[selectedContactKey].id.indexOf('other_contact_') > -1) {
                                selectedContacts[selectedContactKey].id = null;
                                selectedContacts[selectedContactKey].name.fullName = selectedContacts[selectedContactKey].contactInfo.email[0].address;
                            }

                            return selectedContacts[selectedContactKey];
                        });

                        this.ICMEmailService.setContactRecipients(selectedContactArray);
                        resolve(selectedContactArray);
                    }
                }.bind(this));
            },
            dialogMode = true;

        this.ContactManagerActionBarFactory.compose(setRecipients.bind(this), dialogMode);
    };

    ContactManagerOutreachViewController.prototype._checkIfOverSelectionLimit = function _checkIfOverSelectionLimit(limit) {
        return ((this.ContactSelector.trueAllSelected && (this.ContactStreamData.totalContacts > limit)) || (this.getSelectedCount(this.ContactSelector.selectedItems) > limit));
    };
}());
